import { DeviationArticleStatus } from "../../../entities/DeviationArticleStatus";

export const compareArticles = (deviationArticles, orderArticles) => {
	const safeDeviationArticles = Array.isArray(deviationArticles) ? deviationArticles : [];
	const safeOrderArticles = Array.isArray(orderArticles) ? orderArticles : [];

	const orderArticlesMap = new Map(
		safeOrderArticles.map((orderArticle) => [orderArticle.article_code, orderArticle])
	);

	return safeDeviationArticles.map((deviationArticle) => {
		const orderArticle = orderArticlesMap.get(deviationArticle.article_code);

		if (!orderArticle) {
			return { ...deviationArticle, article_status: DeviationArticleStatus.ADD };
		}

		if (deviationArticle.article_status !== DeviationArticleStatus.RESOLVED) {
			if (Number(deviationArticle.article_units) !== Number(orderArticle.units)) {
				return {
					...deviationArticle,
					order_article_units: orderArticle.units,
					article_status: DeviationArticleStatus.CONFLICT,
				};
			} else {
				return { ...deviationArticle, article_status: DeviationArticleStatus.IGNORE };
			}
		}
		return deviationArticle;
	});
};
